<ng-template #createDealTeam>
  <div id="acceptDiv" *ngIf="showCreate">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{header}} Contact</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="dealContactForm" autocomplete="off">
        <div class="form-group">

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Property/Portfolio
                  <span class="star">*</span>
                </label>
                 <mat-form-field  >
                  <mat-select [(ngModel)]="dealContactInputModel.DataEntryPropertyIds" 
                              (ngModelChange)="onChange($event)" 
                              formControlName="lstProperty"
                              placeholder="Select Property/Portfolio"
                              multiple (click)="addClassToOverlayContainer();">
                  @if (dealContactInputModel?.DataEntryPropertyIds?.length > 1) {
                    <mat-select-trigger>
                      <span>{{ dealContactInputModel?.DataEntryPropertyIds?.length }} items selected</span>
                    </mat-select-trigger>
                  }
                  <mat-option>
                      <ngx-mat-select-search
                          #searchKey
                          [disableInitialFocus]="true"
                          [hideClearSearchButton]="true"
                          placeholderLabel="Search here"
                          noEntriesFoundLabel="Nothing found..."
                          [enableClearOnEscapePressed]="true"
                      ></ngx-mat-select-search>
                   </mat-option>
                    @for (property of userAddedPropertyList | arraySearch : 'name' : searchKey.value; track property) {
                      <mat-option [value]="property.id" class="multi-dropdown-item">{{property.name}}</mat-option>
                    }
                    @if (userAddedPropertyList.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div *ngIf="(lstProperty.invalid && isSubmitted) ||(lstProperty.invalid && (lstProperty.dirty || lstProperty.touched))">
                  <p class="redtext" *ngIf="lstProperty.errors.required">
                    Property/Portfolio is required
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  First Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtFirstName" placeholder="First Name" dropSpecialCharacters="false" maxlength="50" [(ngModel)]="dealContactInputModel.FirstName"
                         class="form-control " required>
                  <div *ngIf="(txtFirstName.invalid && isSubmitted)|| (txtFirstName.invalid && (txtFirstName.dirty || txtFirstName.touched))">
                    <p class="redtext" *ngIf="txtFirstName.errors.required">
                      First Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Last Name
                  <span class="star">*</span>
                </label>
                <div>
                  <input type="text" formControlName="txtLastName" placeholder="Last Name" dropSpecialCharacters="false" maxlength="50" [(ngModel)]="dealContactInputModel.LastName"
                         class="form-control " required>
                  <div *ngIf="(txtLastName.invalid && isSubmitted)|| (txtLastName.invalid && (txtLastName.dirty || txtLastName.touched))">
                    <p class="redtext" *ngIf="txtLastName.errors.required">
                      Last Name is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Contact Type
                  <span class="star">*</span>
                </label>
                <label class="select">
                  <select class="form-control" formControlName="lstRole" [(ngModel)]="dealContactInputModel.ContactTypeId">
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let item of contactTypes" [(ngValue)]="item.Id">{{item.ContactType}}</option>
                  </select>
                  <i></i>
                </label>
                <div *ngIf="(lstRole.invalid && isSubmitted) ||(lstRole.invalid && (lstRole.dirty || lstRole.touched))">
                  <p class="redtext" *ngIf="lstRole.errors.required">
                    Contact Type is required
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Email
                </label>
                <div>
                  <input formControlName="txtEmail" placeholder="Email Address" [(ngModel)]="dealContactInputModel.Email"
                         class="form-control ">
                  <div *ngIf="(txtEmail.invalid && isSubmitted )||(txtEmail.invalid && (txtEmail.dirty || txtEmail.touched))">
                    <p class="redtext" *ngIf="txtEmail.errors.EmailCheck">
                      Invalid Email Address
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label class="form-label">
                  Phone
                </label>
                <div>
                  <input type="text" formControlName="txtPhone" placeholder="Phone Number" mask='(000) 000-0000' [(ngModel)]="dealContactInputModel.Phone"
                         class="form-control ">
                  <div *ngIf="(txtPhone.invalid && isSubmitted )||(txtPhone.invalid && (txtPhone.dirty || txtPhone.touched))">
                    <p class="redtext" *ngIf="txtPhone.errors.minlength">
                      Invalid Phone no.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!--<div class="form-group">
              <textarea class="form-control textarea-min-height" maxlength="4000"  required type="text" placeholder="Please enter comments"></textarea>
              <p class="redtext">Please enter comments </p>
          </div>-->
          <div class="text-right">
            <button class="btn btn-default btn-lg" id="closeModal" (click)="cancel()">Cancel</button>
            <button type="button" [disabled]="disableButton" (click)="addDealTeam()" class="btn btn-success btn-lg">{{header}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<div class="d-flex margin-bottom-15 margin-top-15 table-actions-hdr">
  <!--<h2 class="mainhead "><span class="text">City List</span></h2>-->
  <div class="ml-auto d-flex">
    <div class="search-sec margin-right-20">
      <input class="form-control" [(ngModel)]="searchText" type="text" maxlength="30" (keyup)='search($event.target.value)' placeholder="Search">
      <i class="fa fa-search icon" aria-hidden="true"></i>
    </div>
    <div class="select-dropdown multiselectdesign multi-check-dropdown margin-right-10">
       <mat-form-field  >
        <mat-select [(ngModel)]="contactTypeIds" 
                    (ngModelChange)="redrawTable()" 
                    placeholder="Filter By Contact type"
                    panelClass="dynamic-width"
                    multiple>

          @if(contactTypeIds?.length > 1) {
            <mat-select-trigger>
              <span>{{ contactTypeIds?.length }} items selected</span>
            </mat-select-trigger>
          }
          @for (contactType of contactTypeList; track contactType) {
            <mat-option [value]="contactType.id" class="multi-dropdown-item">{{contactType.name}}</mat-option>
          }
          @if (contactTypeList.length === 0) {
            <mat-option class="matoptionnodata" disabled>
              Nothing found...
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="leftside clearfix">
    <div class="d-flex flex-direction-colum flex-1">
      <button class="right-btn btn btn-addgreen btn-lg" style="background: #198fde !important; border-color: #198fde !important;" (click)="create(false);">Add Contact</button>
    </div>
  </div>
 
</div>
<div class="cf list-table">
  <div class="table-responsive">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
      <thead>
        <tr>
          <th data-orderable="false">
            Actions
          </th>
          <th>
            First Name
          </th>
          <th>
            Last Name
          </th>
          <th>
            Contact Type
          </th>
          <th>
            Email
          </th>
          <th>
            Phone
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let deal of filterData; let i=index">
          <td style="width:10%" class="whitespacenowrap">
            <a href="javascript:void(0);" (click)="edit(deal);" class="blueone" tooltip="Edit" placement="top" *ngIf="deal.ContactTypeId > 0">
              <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
            </a>
            <a href="javascript:void(0);" (click)="openDeleteModal(RemoveDealContact, '', deal.MasterContactId);" class="blueone" tooltip="Remove" placement="top" *ngIf="deal.ContactTypeId > 0">
              <i class="icofont icofont-close" aria-hidden="true"></i>
            </a>
          </td>
          <td>{{deal.FirstName}}</td>
          <td>{{deal.LastName}}</td>
          <td>{{deal.ContactType}}</td>
          <td>{{deal.Email ? deal.Email : '-'}}</td>
          <td>{{deal.Phone ? (deal.Phone | phone) : '-'}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="filterData?.length == 0 &&!IsLoading">
          <td colspan="8" class="odd no-data-available">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>No Data Available</p>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<ng-template #RemoveDealContact>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Portfolio Contact</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to remove this Portfolio Contact ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDelete.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="delete();">Remove</button>
    </div>
  </div>

</ng-template>
